import { ERegisterType } from 'api/public';
import { shouldUseKlarityUi } from 'utils/common';
import { Request } from '../request';

export const getPayPlanList = () =>
    Request.get({ url: '/schedule-server/payPlan/list' });

export const getPayLink = (planId: number, jumpMetaData?: Record<string, string>, promotionCode?: string) => {
    const data: any = {
        planId,
        providerType: shouldUseKlarityUi() ? ERegisterType.KLARITY_PORTAL : ERegisterType.KIWI_PORTAL,
    };
    if (promotionCode) {
        data.promotionCode = promotionCode;
    }
    // 为了区分付费是PLAN还是channel，然后跳转不同的页面/走不同的逻辑
    data.jumpMetaData = {
        payFor: 'plan',
    };
    if (jumpMetaData) {
        data.jumpMetaData = {
            ...data.jumpMetaData,
            ...jumpMetaData,
        };
    }
    return Request.post({ url: '/schedule-server/payPlan/pay', params: data });
};

export const getProviderPlan = () =>
    Request.get({ url: '/schedule-server/payPlan/getProviderPlan' });

export const getProviderPaidPlanDetails = () =>
    Request.get({ url: '/schedule-server/provider/stat' });

export const getChannelPayLink = (channelId: number) =>
    Request.post({ url: '/schedule-server/payPlan/payChannel', params: { channelId, providerType: shouldUseKlarityUi() ? ERegisterType.KLARITY_PORTAL : ERegisterType.KIWI_PORTAL } });

export const getBillingPortalLink = () =>
    Request.get({ url: '/schedule-server/payPlan/billPortal' });

export const getProviderAgreement = () => Request.get({ url: '/schedule-server/payPlan/contract' });

export const checkCoupon = (promotionCode: string) => Request.get({ url: '/schedule-server/payment/getCheckByPromotionCode', params: { promotionCode } });
